"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLogisticRouteToDeliveryType = convertLogisticRouteToDeliveryType;
/* eslint-disable @typescript-eslint/naming-convention */
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
function convertLogisticRouteToDeliveryType(logisticRoute) {
    return logisticRouteMap[logisticRoute];
}
const logisticRouteMap = {
    [module_logistic_interfaces_1.LogisticRoute.ClickAndCollect]: module_logistic_interfaces_1.DeliveryType.ClickAndCollect,
    [module_logistic_interfaces_1.LogisticRoute.HomeDelivery]: module_logistic_interfaces_1.DeliveryType.Shipping,
    [module_logistic_interfaces_1.LogisticRoute.PickupPoint]: module_logistic_interfaces_1.DeliveryType.Shipping,
    [module_logistic_interfaces_1.LogisticRoute.StoreDelivery]: module_logistic_interfaces_1.DeliveryType.ClickAndCollect
};
